import React, { useEffect, useState } from 'react';
import './index.css';
import ZigzagCalculator from './ZigzagCalculator';
import CoilWeightCalculator from './coil';
import { getInitialLang, getTranslations, SUPPORTED_LANGS, LANG_NAMES } from './i18n';

const App = () => {
    const [lang, setLang] = useState(getInitialLang);
    const [activeTab, setActiveTab] = useState('coil'); // 'coil' | 'zigzag'

    const t = getTranslations(lang);

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const tabBase = "px-5 py-2.5 rounded-xl text-sm font-bold transition-colors cursor-pointer";
    const tabActive = "bg-white text-gray-800 shadow";
    const tabInactive = "text-gray-500 hover:text-gray-700";

    return (
        <div className="min-h-screen p-4 sm:p-8" style={{
            background: '#ffffff',
            fontFamily: "'DM Sans', sans-serif"
        }}>
            <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />

            <div className="max-w-6xl mx-auto">
                {/* Tab bar + dil seçici */}
                <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mb-6">
                    <div className="flex gap-1 bg-gray-200/70 rounded-2xl p-1.5">
                        <button
                            type="button"
                            onClick={() => setActiveTab('coil')}
                            className={`${tabBase} ${activeTab === 'coil' ? tabActive : tabInactive}`}
                        >
                            {t.tabCoil}
                        </button>
                        <button
                            type="button"
                            onClick={() => setActiveTab('zigzag')}
                            className={`${tabBase} ${activeTab === 'zigzag' ? tabActive : tabInactive}`}
                        >
                            {t.tabZigzag}
                        </button>
                    </div>

                    <select
                        value={lang}
                        onChange={(e) => setLang(e.target.value)}
                        className="px-3 py-2 rounded-xl border border-gray-300 bg-white text-sm font-medium text-gray-700 focus:outline-none focus:border-blue-400"
                        aria-label="Language"
                    >
                        {SUPPORTED_LANGS.map((code) => (
                            <option key={code} value={code}>{LANG_NAMES[code]}</option>
                        ))}
                    </select>
                </div>

                {/* Sorumluluk reddi */}
                <p className="mb-6 text-xs text-gray-500 text-center max-w-3xl mx-auto">
                    {t.disclaimer}
                </p>

                {activeTab === 'coil'
                    ? <CoilWeightCalculator t={t} lang={lang} />
                    : <ZigzagCalculator t={t} lang={lang} />}
            </div>
        </div>
    );
};

export default App;